export const RECONCILIATION_FETCH_SUCCESS = 'RECONCILIATION_FETCH_SUCCESS';
export const LEDGER_FETCH_SUCCESS = 'LEDGER_FETCH_SUCCESS';
export const LEDGER_FETCH_ERROR = 'LEDGER_FETCH_ERROR';
export const REMOVE_LEADER_DATA = 'REMOVE_LEADER_DATA';
export const LEADER_TRANSACTION_DATA = 'LEADER_TRANSACTION_DATA';
